export default {
    handle(bloodDonorModel) {
        if (!bloodDonorModel.birthdate) {
            return true;
        }

        bloodDonorModel.birthdate = bloodDonorModel.birthdate.replaceAll('/', '.');

        return true;
    }
}